import { cloudFunction } from 'services/parse';

export const createUserRequestedItem = (data: Record<string, any>)=>{
  return cloudFunction('createUserRequestedItem',data);
};

export const deleteUserRequestedItem = (id: string)=>{
  return cloudFunction('deleteUserRequestedItem',{ id });
};

export const fetchUserRequestedItemDetail = (id: string)=>{
  return cloudFunction('fetchUserRequestedItemDetail',{ userRequestedItemId: id });
};

export const fetchUserRequestedItems = (data: Record<string, any>)=>{
  return cloudFunction('fetchUserRequestedItems', data);
};